import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children, activeFilterLabel }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`

  return (
    <x-modal
      data-id={id}
      data-toggle-group="true"
      className="group/filter dropdown-modal flex flex-col border-b first:border-t border-neutrals-light-grey"
    >
      <button
        data-modal-role="toggle"
        data-modal-parent={id}
        className="flex min-h-[56px] w-full items-center justify-between md-max:px-4 py-2"
      >
        <span>
          {label}
          {activeFilterLabel ? (
            <span className="text-neutrals-secondary-grey"> ({activeFilterLabel})</span>
          ) : null}
        </span>
        <Icon id="plus" className="shrink-0 group-data-visible/filter:hidden" />
        <Icon id="minus" className="hidden shrink-0 group-data-visible/filter:block" />
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col overflow-hidden md-max:px-4">{children}</div>
      </div>
    </x-modal>
  )
}
